import React from 'react';
import { identification } from '../data/content';
export function PainPoints() {
  return <section className="bg-cream-deep text-ink" data-id="element-179" data-mp="2ln2h4cs1zjrl">
      <div className="mx-auto max-w-content px-5 py-16 sm:px-6 lg:grid lg:grid-cols-[0.9fr_1.1fr] lg:gap-16 lg:py-24" style={{
      paddingTop: "50px"
    }} data-id="element-180" data-mp="2lmsmuczz6qg3">
        <h2 className="font-display text-[2rem] font-semibold leading-[1.1] text-brown sm:text-[2.6rem] lg:sticky lg:top-16 lg:self-start" data-id="element-181" data-mp="2bwzerlz1ktgl">
          {identification.headline}{' '}
          <em className="font-display italic text-rose-deep" data-id="element-182" data-mp="21zcvyoemghrc">{identification.headlineAccent}</em>
        </h2>

        <div className="mt-8 lg:mt-0" data-id="element-183" data-mp="1nztqy4h3xmj9">
          <ul className="divide-y divide-gold/25 border-y border-gold/25" data-id="element-184" data-mp="1o0vbr0nxdne6">
            {identification.situations.map(situation => <li key={situation} className="flex gap-4 py-4 sm:py-5" data-id="element-185" data-mp="1sywv7mp9joq6">
                <span aria-hidden="true" className="mt-2 h-1.5 w-1.5 flex-none rotate-45 bg-rose" data-id="element-186" data-mp="3iemh3nz81l3t" />
                <p className="font-sans text-[0.98rem] leading-relaxed text-ink sm:text-[1.05rem]" data-id="element-187" data-mp="3nbcyqfqocorc">
                  {situation}
                </p>
              </li>)}
          </ul>

          <p className="mt-8 font-display text-[1.45rem] font-medium italic leading-snug text-brown sm:text-2xl" data-id="element-188" data-mp="1u2dgub08p8vf">
            {identification.hope}
          </p>
        </div>
      </div>
    </section>;
}